import React from "react";
import PropTypes from "prop-types";
import { Field } from "react-final-form";
import { AnimateSharedLayout } from "framer-motion";
import Fade from "../animate/Fade";

export const Error = ({ name }) => (
  <Field
    name={name}
    subscribe={{ touched: true, error: true }}
    render={({
      meta: {
        touched,
        error,
        data: { warning },
      },
    }) => (
      <AnimateSharedLayout exitBeforeEnter>
        <Fade show={!!(touched && error)}>
          <span className="error">{error}</span>
        </Fade>
        <Fade show={!!(warning && !(touched && error))}>
          <span className="warning">{warning}</span>
        </Fade>
      </AnimateSharedLayout>
    )}
  />
);

Error.propTypes = {
  name: PropTypes.string.isRequired,
};

export const required =
  (message = "This field is required") =>
  (value) =>
    value ? undefined : message;

export const requiredIfNot =
  (...fields) =>
  (value, allValues) =>
    fields.every(
      (field) => !field.split(".").reduce((o, i) => o[i], allValues)
    ) && !value
      ? "This field is required"
      : undefined;

export const requiredIf =
  (...fields) =>
  (value, allValues) =>
    fields.some((field) =>
      field
        .split(".")
        .reduce((o, i) => (o !== undefined ? o[i] : false), allValues)
    ) && !value
      ? "This field is required"
      : undefined;

export const mustBeNumber = (value) =>
  Number.isNaN(value) ? "Must be a number" : undefined;

export const composeValidators =
  (...validators) =>
  (value, allValues) =>
    validators.reduce(
      (error, validator) => error || validator(value, allValues),
      undefined
    );

export const isEmail = (value) => {
  if (value) {
    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailPattern.test(value.trim().toLowerCase())
      ? undefined
      : "Please enter a valid email address";
  }
  return undefined;
};

export const isLongDistance = (value, allValues) =>
  allValues.moving_from &&
  value &&
  allValues.moving_from.substr(0, 4) === value.substr(0, 4) ? (
    <>
      National Van Lines provides long distance moving services. For local
      moving options please{" "}
      <a href="https://www.nationalvanlines.com/find-an-agent/">
        search our agent directory
      </a>{" "}
      for a mover near you
    </>
  ) : undefined;
